import Axios from 'axios';
import appUrl from '../../config/appUrl';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const generateTicketsSlice = createSlice({
    name: 'generateTickets',
    initialState: {
        data: []
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateTickets.pending, (state, action) => {
                return { ...state, loading: true }
            })
            .addCase(generateTickets.fulfilled, (state, action) => {
                return { ...state, loading: false, data: action.payload }
            })
            .addCase(generateTickets.rejected, (state, action) => {

                return {
                    ...state,
                    loading: false,
                    error: action.payload
                }
            });
    },
});

export default generateTicketsSlice.reducer;


// Thunks
// department Get Thunk
export const generateTickets = createAsyncThunk('generateTicket/fetch', async (numberOfCodes, { rejectWithValue, fulfillWithValue }) => {

    try {
        const { data } = await Axios.post(appUrl.baseUrl + appUrl.generateTickets, {
            "numberOfCodes": numberOfCodes
        });
        return fulfillWithValue(data);
    } catch (error) {

        throw rejectWithValue(error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message)
    }

});


